import sendMessage from "../../../utils/chromeMessages.js";

export default function stopCurrentExport(): Promise<true | "no_ongoing_export"> {
    return sendMessage({
        action: "CURRENT_IMPORT/STOP",
    });
}
